// Cariden Tahsilat penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.collectPayment';

export const accountCollectPaymentGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Cariden tahsilat nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, bir cariden aldığınız ödemeyi resmi ve izlenebilir şekilde kaydeder. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve cari'),
    body: t(`${G}.regions.body`, 'Tahsilat formu'),
    footer: t(`${G}.regions.footer`, 'Tamamla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Cariden gelen tutarı seçtiğiniz ödeme yöntemiyle (nakit, banka, POS vb.) kaydeder ve cari bakiyeyi güncel tutar. Kayıt, muhasebe ve denetim için belge niteliği taşır. Üstteki kartta carinin adı ve güncel bakiyesi görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Cari hesap bakiyesinin doğru görünmesini sağlar.'),
        t(`${G}.s1.tip2`, 'Tahsilatın hangi kanaldan (kasa / banka) alındığını net şekilde kayda geçirir.'),
        t(`${G}.s1.tip3`, 'Belge numarası ve işlem tarihi, sonradan kontrolü ve mutabakatı kolaylaştırır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Para birimi, ödeme yöntemi ve şube'),
      text: t(`${G}.s2.text`, 'Önce para birimini seçin; kasa ve banka listeleri yalnız bu para birimindeki hesapları gösterir. Sonra ödeme yöntemini seçin: Nakit, Kredi Kartı, Havale/EFT, Çek, POS veya Tahakkuk.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube boş bırakılırsa ("Genel") hareket carinin şubesine yazılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kasa veya banka hesabını seçin'),
      text: t(`${G}.s3.text`, 'Nakit seçildiyse bir kasa, diğer yöntemlerde (Kredi Kartı, Havale/EFT, Çek, POS) bir banka hesabı seçilir. Tahsil edilen tutar seçtiğiniz kasa veya banka hesabının bakiyesine eklenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Nakit / Havale-EFT / POS / Çek: ilgili kasa veya banka bakiyesi etkilenir.'),
        t(`${G}.s3.tip2`, 'Tahakkuk: kasa / banka alanı gizlenir; kasa veya banka bakiyesi değişmez, yalnız cari hareket kaydı oluşur.'),
        t(`${G}.s3.tip3`, 'Listede "Uygun kasa / banka hesabı bulunamadı" yazıyorsa seçtiğiniz para biriminde hesap yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Tarih, belge numarası ve tutar'),
      text: t(`${G}.s4.text`, 'İşlem tarihi varsayılan olarak bugündür; ileri veya geri tarihli kayıt yapabilirsiniz. Belge numarası otomatik gelir (THB-…), dilerseniz değiştirin; boş bırakılamaz. Tutarı 1.000,00 biçiminde, sıfırdan büyük girin.'),
      tips: [
        t(`${G}.s4.tip1`, 'Seçilen tarih bugünden 30 günden fazla uzaksa kaydetmeden önce onay istenir.'),
        t(`${G}.s4.tip2`, 'Açıklama isteğe bağlıdır; boş bırakılırsa "… carisinden tahsilat" yazılır.'),
        t(`${G}.s4.tip3`, 'Proje alanından hareketi bir projeye bağlayabilirsiniz (isteğe bağlı).'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Tahsilatı tamamlayın'),
      text: t(`${G}.s5.text`, '"Tahsilatı Tamamla" düğmesi zorunlu alanlar dolunca açılır. Kayıttan sonra carinin borcu tahsilat tutarı kadar azalır ve tahsilat makbuzu otomatik açılır; oradan yazdırabilirsiniz. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
